import { render, staticRenderFns } from "./PeopleSlider.vue?vue&type=template&id=2c4e2912&scoped=true&"
import script from "./PeopleSlider.vue?vue&type=script&lang=js&"
export * from "./PeopleSlider.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSlider.vue?vue&type=style&index=0&id=2c4e2912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e2912",
  null
  
)

export default component.exports